/* HHQ cart speed-up. Two things only:
   1) The quantity +/- buttons update the number at once and combine fast clicks into one request.
   2) The theme's extra "GET /cart.js" before every quantity change is answered from a fresh copy
      when we already hold one (saves one network round trip).
   Remove the <script> line for this file in snippets/theme-globals.liquid to switch it off. */
(function () {
  if (window.__hhqCartSpeed || window.HHQ_CART_SPEED_OFF) return;
  window.__hhqCartSpeed = true;

  /* ---- 2) cart.js cache ---- */
  var cache = null, cacheAt = 0, MAX_AGE = 8000;
  var origFetch = window.fetch;
  if (typeof origFetch === 'function' && typeof Response === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var path = url.split('?')[0];
        var isCartGet = method === 'GET' && /\/cart\.js$/.test(path);
        if (isCartGet && cache && Date.now() - cacheAt < MAX_AGE) {
          return Promise.resolve(new Response(JSON.stringify(cache), { status: 200, headers: { 'Content-Type': 'application/json' } }));
        }
        if (/\/cart\/(add|update|clear)(\.js)?$/.test(path)) cache = null;
        var p = origFetch.apply(this, arguments);
        if (isCartGet || /\/cart\/change(\.js)?$/.test(path)) {
          p.then(function (r) {
            if (!r || !r.ok) { cache = null; return; }
            r.clone().json().then(function (j) {
              if (j && j.items) { cache = j; cacheAt = Date.now(); }
            }).catch(function () { cache = null; });
          }).catch(function () { cache = null; });
        }
        return p;
      } catch (e) {
        return origFetch.apply(this, arguments);
      }
    };
  }

  /* ---- 3) no fade on the quantity box while the cart saves (stops the flash) ---- */
  try {
    var st0 = document.createElement('style');
    st0.setAttribute('data-hhq', 'cart-speed');
    st0.textContent = '.quick-cart .quantity-input.pending-quantity-update button,.quick-cart .quantity-input.pending-quantity-update input{opacity:1 !important}';
    (document.head || document.documentElement).appendChild(st0);
  } catch (e) {}

  /* ---- 1) instant number + combined clicks ---- */
  var pend = {}, passing = false;
  document.addEventListener('click', function (e) {
    if (passing) return;
    var btn = e.target && e.target.closest && e.target.closest('[data-add-quantity],[data-subtract-quantity]');
    if (!btn) return;
    var item = btn.closest('[data-input-item]');
    var input = item && item.querySelector('[data-quantity-input]');
    if (!item || !input || !item.dataset.key) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var key = item.dataset.key;
    var st = pend[key];
    if (!st) { st = pend[key] = { base: parseInt(input.value, 10) || 0 }; st.target = st.base; }
    st.target = Math.max(0, st.target + (btn.hasAttribute('data-add-quantity') ? 1 : -1));
    input.value = st.target;
    clearTimeout(st.timer);
    st.timer = setTimeout(function () { flush(key, item, input); }, 250);
  }, true);

  function flush(key, item, input) {
    var st = pend[key];
    delete pend[key];
    if (!st || !document.body.contains(item)) return;
    if (st.target === st.base) { input.value = st.base; return; }
    var up = st.target > st.base;
    var btn = item.querySelector(up ? '[data-add-quantity]' : '[data-subtract-quantity]');
    if (!btn) { input.value = st.base; return; }
    /* the theme adds or subtracts 1 from the box, so pre-set it one step away from the target */
    input.value = up ? st.target - 1 : st.target + 1;
    passing = true;
    try { btn.click(); } finally { passing = false; }
    /* the theme has read the box by now; show the real target again so it does not flash back */
    input.value = st.target;
  }
})();
